const error_codes = {
	'200': 'Sikeres művelet',
	'400': 'A rendszer nem tudta elvégezni a műveletet.',
	'401': 'A művelet elvégzéséhez be kell jelentkeznie.',
	'403': 'A művelet elvégzéséhez nincs jogosultsága.',
	'404': 'Nem létező adat, a művelet nem végezhető el.',
	'422': 'A megadott adatokkal a művelet nem végezhető el.',
	'500': 'Ismeretlen rendszerhiba.',
	general: 'Ismeretlen hiba történt.'
}

class ValidationError extends Error {

	constructor (validation_messages = {}, ...params) {
		// Pass remaining arguments (including vendor specific ones) to parent constructor
		super(...params)

		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, ValidationError)
		}

		this.name = 'ValidationError'
		this.validation_messages = validation_messages
	}
}

export {
	error_codes,
	ValidationError
}
